module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "pull-right",
    attrs: {
      "id": "flags"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "id": "br"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setPtBr()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./flags/br.gif")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "es"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setEs()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./flags/es.gif")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "us"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setEn()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./flags/us.gif")
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27f141b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/header/flags.vue
// module id = 903
// module chunks = 2